import { render, staticRenderFns } from "./verProduto.vue?vue&type=template&id=222edcc8"
import script from "./verProduto.ts?vue&type=script&lang=js&external"
export * from "./verProduto.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222edcc8')) {
      api.createRecord('222edcc8', component.options)
    } else {
      api.reload('222edcc8', component.options)
    }
    module.hot.accept("./verProduto.vue?vue&type=template&id=222edcc8", function () {
      api.rerender('222edcc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produto/verProduto.vue"
export default component.exports